import { Button, ButtonTheme } from 'components/Button';
import { ICONS } from 'components/Icon';
import { ViewWithSeparators } from 'components/ViewWithSeparators';
import { theme } from 'lib/theme';
import * as React from 'react';
import { View } from 'react-native';
import { NavigationHeader } from 'components/NavigationHeader';
import { SidebarShowButton } from 'componentsAware/SidebarShowButton';
import { Txt } from 'components/Txt';
import { NAVIGATE_MODAL } from 'store/actions';
import { ModalScreens } from 'components/Navigation/types';
import { useDispatch } from 'react-redux';
import { EngagePropertyListItem } from 'types/Engage';
import { ScreenSize } from 'lib/constants';
import { useScreenSize } from 'hooks/useScreenSize';

type Props = {
  onBackPress: () => void;
  property: EngagePropertyListItem;
  pageKey: string;
};
export const ScheduledVisitsHeader: React.FC<Props> = ({
  onBackPress,
  property,
  pageKey,
}) => {
  const dispatch = useDispatch();
  const screenSize = useScreenSize();

  const handleOpenScheduledVisitModal = React.useCallback(() => {
    dispatch(
      NAVIGATE_MODAL({
        screen: ModalScreens.EngageFlatDoorScheduledVisit,
        size: 'large',
        params: {
          propertyId: property.id,
          pageKey,
        },
      }),
    );
  }, [dispatch, property.id, pageKey]);

  return (
    <View>
      <NavigationHeader marginRight={0} marginLeft={0}>
        <SidebarShowButton />
        <ViewWithSeparators
          horizontal
          style={{
            alignItems: 'center',
            flex: 1,
          }}
          separatorMargin={theme.paddingHorizontalHalf}
          separatorColor="transparent"
        >
          <Button
            icon={ICONS.ChevronLeftLight}
            text="Engage"
            buttonTheme={ButtonTheme.header}
            onPress={onBackPress}
            style={{
              paddingLeft: theme.paddingHorizontalHalf,
              paddingRight: theme.paddingHorizontal,
            }}
            chipLike
          />
          <Txt weight="bold" numberOfLines={1} style={{ flex: 1 }}>
            Scheduled Visits
          </Txt>
          <Button
            icon={ICONS.PlusLight}
            text={
              screenSize === ScreenSize.small
                ? 'Schedule a Visit'
                : 'Create New Scheduled Visit'
            }
            buttonTheme={ButtonTheme.header}
            onPress={handleOpenScheduledVisitModal}
            style={{
              paddingLeft: theme.paddingHorizontalHalf,
              paddingRight: theme.paddingHorizontal,
            }}
            chipLike
          />
        </ViewWithSeparators>
      </NavigationHeader>
    </View>
  );
};
